<template>
  <div id="goTop" v-show="goTopShow">
    <div class="goTop" @click="goTop">
      <div class="arrow"></div>
      <div class="text">顶部</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "goTop",
  data() {
    return {
      scrollTop: "",
      goTopShow: false,
    };
  },
  methods: {
    handleScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.scrollTop > 500) {
        this.goTopShow = true;
      } else {
        this.goTopShow = false;
      }
    },
    goTop() {
      let timer = null,
        that = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (that.scrollTop > 0) {
          that.scrollTop -= 50;
          document.body.scrollTop = document.documentElement.scrollTop =
            that.scrollTop;
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
          that.goTopShow = false;
        }
      });
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
#goTop {
  position: fixed;
  right: 40px;
  bottom: 148px;
  z-index: 999999999;
}

.goTop {
  width: 58px;
  height: 58px;
  background: rgba(0, 0, 0, 1);
  opacity: 0.5;
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }
}

.arrow {
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-bottom-color: white;
  margin-bottom: 7px;
  margin-top: -9px;
}

.text {
  height: 14px;
  font-size: 14px;
  color: white;
  line-height: 1;
}
</style>
